import { Typography } from "@mui/material";
import { ConfirmationDialog } from "~/components/ConfirmationDialog/ConfirmationDialog";

export type RemoveUserDialogProps = {
  isOpen: boolean;
  userName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export function RemoveUserDialog({
  isOpen,
  userName,
  onConfirm,
  onCancel,
  isLoading = false,
}: RemoveUserDialogProps) {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onConfirm={onConfirm}
      onClose={onCancel}
      loading={isLoading}
      title="Remove User"
      confirmButtonText="Remove User"
      content={
        <Typography>
          Are you sure you want to remove <strong>{userName}</strong> from this
          organization? This will revoke all their access to spaces and
          resources within this organization.
        </Typography>
      }
    />
  );
}
